import { render } from "./pins5.vue?vue&type=template&id=56fc2336&scoped=true"
import script from "./pins5.vue?vue&type=script&lang=js"
export * from "./pins5.vue?vue&type=script&lang=js"

import "./pins5.vue?vue&type=style&index=0&id=56fc2336&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fc2336"]])

export default __exports__